export default "__VITE_ASSET__f4e33e85__"